<template>
  <div
    id="airportTransfer"
    :class="mode === 'airport-transfer' ? 'tab-pane in active' : 'tab-pane'"
  >
    <div class="search__box">
      <button
        class="close-btn"
        @click="$emit('closeModal')"
        v-if="modifySearch"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 512 512"
        >
          <path
            d="M289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34z"
            fill="currentColor"
          ></path>
        </svg>
      </button>
      <form @submit.prevent="search" id="searchTransportation">
        <template v-if="hasCompanySelector">
          <div class="search__option-box">
            <div class="col-sm-12">
              <div class="row">
                <div class="col-sm-6">
                  <label class="depart-point">Address, Airport or Area</label>
                </div>
                <div class="col-sm-6" style="padding-left: 35px">
                  <label class="drop-point">Address, Airport or Area</label>
                </div>
              </div>
            </div>
          </div>
          <div class="search__box-inputBox">
            <div class="row">
              <div class="wrapping__search-row">
                <div class="col-sm-12 search--boxPhase-1">
                  <div class="wrap__input-box">
                    <div class="col-sm-6">
                      <!-- Start: Airport on Departure -->
                      <div class="pos-rel" v-if="isDepartureFromAirport">
                        <i class="ic-marker-maps"></i>
                        <input
                          class="searchBox__input searchBox__input-from"
                          :class="{
                            'field-error':
                              isSubmitted &&
                              $v.searchRequest.pickUpLocation.name.$error,
                          }"
                          type="text"
                          autocomplete="off"
                          tabindex="1"
                          name="airportPickUpLocation"
                          v-model="searchRequest.pickUpLocation.name"
                          @keyup="onKeyupAutoComplete($event.target)"
                          @focus="onFocusAutoComplete($event.target)"
                          @blur="onBlurAutoComplete($event.target)"
                        />
                        <div class="list-autoComplete pickup-autoComplete">
                          <ul
                            class="autoComplete-results"
                            id="pickup-airportAutoCompleteResults"
                          ></ul>
                        </div>
                      </div>
                      <!-- End: Airport on Departure -->
                      <!-- Start: Airport on Arrival -->
                      <div class="pos-rel" v-if="!isDepartureFromAirport">
                        <i class="ic-marker-maps"></i>
                        <input
                          class="searchBox__input searchBox__input-from"
                          :class="{
                            'field-error':
                              isSubmitted &&
                              $v.searchRequest.pickUpLocation.name.$error,
                          }"
                          type="text"
                          autocomplete="off"
                          tabindex="2"
                          name="airportPickUpLocation"
                          v-model="searchRequest.pickUpLocation.name"
                          @keyup="onKeyupAutoComplete($event.target)"
                          @focus="onFocusAutoComplete($event.target)"
                          @blur="onBlurAutoComplete($event.target)"
                        />
                        <div class="list-autoComplete pickup-autoComplete">
                          <ul
                            class="autoComplete-results"
                            id="pickup-airportAutoCompleteResults"
                          ></ul>
                        </div>
                      </div>
                      <!-- End: Airport on Arrival -->
                    </div>
                    <!-- /.col-sm-6 -->
                    <div class="switch-But" @click="swapLocation()">
                      <i class="ic-switch"></i>
                    </div>
                    <div class="col-sm-6">
                      <!-- Start: Airport on Departure -->
                      <div class="pos-rel" v-if="isDepartureFromAirport">
                        <i class="ic-marker-maps"></i>
                        <input
                          class="searchBox__input searchBox__input-to"
                          :class="{
                            'field-error':
                              isSubmitted &&
                              $v.searchRequest.dropOffLocation.name.$error,
                          }"
                          type="text"
                          autocomplete="off"
                          tabindex="2"
                          name="airportDropOffLocation"
                          v-model="searchRequest.dropOffLocation.name"
                          @keyup="onKeyupAutoComplete($event.target)"
                          @focus="onFocusAutoComplete($event.target)"
                          @blur="onBlurAutoComplete($event.target)"
                        />
                        <div class="list-autoComplete dropoff-autoComplete">
                          <ul
                            class="autoComplete-results"
                            id="dropoff-airportAutoCompleteResults"
                          ></ul>
                        </div>
                      </div>
                      <!-- End: Airport on Departure -->
                      <!-- Start: Airport on Arrival -->
                      <div class="pos-rel" v-if="!isDepartureFromAirport">
                        <i class="ic-marker-maps"></i>
                        <input
                          class="searchBox__input searchBox__input-to"
                          :class="{
                            'field-error':
                              isSubmitted &&
                              $v.searchRequest.dropOffLocation.name.$error,
                          }"
                          type="text"
                          autocomplete="off"
                          tabindex="1"
                          name="airportDropOffLocation"
                          v-model="searchRequest.dropOffLocation.name"
                          @keyup="onKeyupAutoComplete($event.target)"
                          @focus="onFocusAutoComplete($event.target)"
                          @blur="onBlurAutoComplete($event.target)"
                        />
                        <div class="list-autoComplete dropoff-autoComplete">
                          <ul
                            class="autoComplete-results"
                            id="dropoff-airportAutoCompleteResults"
                          ></ul>
                        </div>
                      </div>
                      <!-- End: Airport on Arrival -->
                    </div>
                    <!-- /.col-sm-6 -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="search__option-box">
            <div class="col-sm-7">
              <div class="row">
                <div class="col-sm-6">
                  <label> Pick-up Date </label>
                  <span
                    class="help-tip cursor-pointer"
                    tabindex="0"
                    data-container="body"
                    data-toggle="popover"
                    data-placement="top"
                    data-content="Local pick-up date."
                  >
                    &#63;
                  </span>
                </div>
                <div class="col-sm-6">
                  <label>Time</label>
                  <span
                    class="help-tip cursor-pointer"
                    tabindex="0"
                    data-container="body"
                    data-toggle="popover"
                    data-placement="top"
                    data-content="Local pick-up time (please enter flight arrival time for airport pick-up)."
                  >
                    &#63;
                  </span>
                </div>
              </div>
            </div>
            <div class="col-sm-5">
              <div class="row">
                <div class="col-sm-6 pl-5">
                  <label> Company </label>
                </div>
              </div>
            </div>
          </div>
          <div class="search__box-inputBox">
            <div class="row">
              <div class="wrapping__search-row">
                <div class="col-sm-8 search--boxPhase-2">
                  <div class="wrap__input-box">
                    <div class="col-sm-6">
                      <i class="ic-date-checkin pl-5"></i>
                      <VueCtkDateTimePicker
                        id="airportPickUpDate"
                        :min-date="minimumPickUpDate"
                        :max-date="maximumPickUpDate"
                        v-model="searchRequest.pickUpDate"
                        color="#025BC5"
                        format="YYYY-MM-DD"
                        formatted="MMM DD, YYYY"
                        auto-close
                        only-date
                        no-label
                        no-header
                        no-button
                        no-button-now
                      />
                    </div>
                    <div class="col-sm-6">
                      <i class="ic-time"></i>
                      <VueCtkDateTimePicker
                        id="airportPickUpTime"
                        v-model="searchRequest.pickUpTime"
                        color="#025BC5"
                        format="HH:mm"
                        formatted="HH:mm"
                        minute-interval="5"
                        overlay
                        only-time
                        no-label
                        no-header
                        no-button
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 search--boxPhase-3">
                  <div class="col-sm-12" style="padding: 0">
                    <v-select
                      class="v-search-select airport-trr-select"
                      id="airport-trr-select"
                      placeholder="Select Company"
                      label="name"
                      :disabled="!hasCompanySelector"
                      v-model="searchRequest.company"
                      :options="companies || companyOption"
                      :clearable="true"
                      :searchable="true"
                      :filterable="true"
                      :reduce="(option) => option.id"
                    ></v-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="search__option-box" id="inline-search-optionBox">
            <div class="col-sm-8">
              <div class="row">
                <div class="col-sm-6">
                  <label class="depart-point">Address, Airport or Area</label>
                </div>
                <div class="col-sm-6 pl-25">
                  <label class="drop-point">Address, Airport or Area</label>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <div class="col-sm-6 pl-5">
                  <label> Pick-up Date </label>
                  <span
                    class="help-tip cursor-pointer"
                    tabindex="0"
                    data-container="body"
                    data-toggle="popover"
                    data-placement="top"
                    data-content="Local pick-up date."
                  >
                    &#63;
                  </span>
                </div>
                <div class="col-sm-6">
                  <label>Time</label>
                  <span
                    class="help-tip cursor-pointer"
                    tabindex="0"
                    data-container="body"
                    data-toggle="popover"
                    data-placement="top"
                    data-content="Local pick-up time (please enter flight arrival time for airport pick-up)."
                  >
                    &#63;
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="search__box-inputBox" id="inline-search-inputBox">
            <div class="row">
              <div class="wrapping__search-row">
                <div class="col-sm-5 search--boxPhase-1">
                  <div class="wrap__input-box">
                    <div class="col-sm-6">
                      <!-- Start: Airport on Departure -->
                      <div class="pos-rel" v-if="isDepartureFromAirport">
                        <i class="ic-marker-maps"></i>
                        <input
                          class="searchBox__input searchBox__input-from"
                          :class="{
                            'field-error':
                              isSubmitted &&
                              $v.searchRequest.pickUpLocation.name.$error,
                          }"
                          type="text"
                          autocomplete="off"
                          tabindex="1"
                          name="airportPickUpLocation"
                          v-model="searchRequest.pickUpLocation.name"
                          @keyup="onKeyupAutoComplete($event.target)"
                          @focus="onFocusAutoComplete($event.target)"
                          @blur="onBlurAutoComplete($event.target)"
                        />
                        <div class="list-autoComplete pickup-autoComplete">
                          <ul
                            class="autoComplete-results"
                            id="pickup-airportAutoCompleteResults"
                          ></ul>
                        </div>
                      </div>
                      <!-- End: Airport on Departure -->
                      <!-- Start: Airport on Arrival -->
                      <div class="pos-rel" v-if="!isDepartureFromAirport">
                        <i class="ic-marker-maps"></i>
                        <input
                          class="searchBox__input searchBox__input-from"
                          :class="{
                            'field-error':
                              isSubmitted &&
                              $v.searchRequest.pickUpLocation.name.$error,
                          }"
                          type="text"
                          autocomplete="off"
                          tabindex="2"
                          name="airportPickUpLocation"
                          v-model="searchRequest.pickUpLocation.name"
                          @keyup="onKeyupAutoComplete($event.target)"
                          @focus="onFocusAutoComplete($event.target)"
                          @blur="onBlurAutoComplete($event.target)"
                        />
                        <div class="list-autoComplete pickup-autoComplete">
                          <ul
                            class="autoComplete-results"
                            id="pickup-airportAutoCompleteResults"
                          ></ul>
                        </div>
                      </div>
                      <!-- End: Airport on Arrival -->
                    </div>
                    <!-- /.col-sm-6 -->
                    <div class="switch-But" @click="swapLocation()">
                      <i class="ic-switch"></i>
                    </div>
                    <div class="col-sm-6">
                      <!-- Start: Airport on Departure -->
                      <div class="pos-rel" v-if="isDepartureFromAirport">
                        <i class="ic-marker-maps"></i>
                        <input
                          class="searchBox__input searchBox__input-to"
                          :class="{
                            'field-error':
                              isSubmitted &&
                              $v.searchRequest.dropOffLocation.name.$error,
                          }"
                          type="text"
                          autocomplete="off"
                          tabindex="2"
                          name="airportDropOffLocation"
                          v-model="searchRequest.dropOffLocation.name"
                          @keyup="onKeyupAutoComplete($event.target)"
                          @focus="onFocusAutoComplete($event.target)"
                          @blur="onBlurAutoComplete($event.target)"
                        />
                        <div class="list-autoComplete dropoff-autoComplete">
                          <ul
                            class="autoComplete-results"
                            id="dropoff-airportAutoCompleteResults"
                          ></ul>
                        </div>
                      </div>
                      <!-- End: Airport on Departure -->
                      <!-- Start: Airport on Arrival -->
                      <div class="pos-rel" v-if="!isDepartureFromAirport">
                        <i class="ic-marker-maps"></i>
                        <input
                          class="searchBox__input searchBox__input-to"
                          :class="{
                            'field-error':
                              isSubmitted &&
                              $v.searchRequest.dropOffLocation.name.$error,
                          }"
                          type="text"
                          autocomplete="off"
                          tabindex="1"
                          name="airportDropOffLocation"
                          v-model="searchRequest.dropOffLocation.name"
                          @keyup="onKeyupAutoComplete($event.target)"
                          @focus="onFocusAutoComplete($event.target)"
                          @blur="onBlurAutoComplete($event.target)"
                        />
                        <!-- <div class="popularCity dropoff-popular">
                        <header>Popular Destinations</header>
                        <ul class="popular-list">
                          <li
                            v-for="(popular, index) in popularDestinations"
                            :key="index"
                            @click="onClickPopularDestination(popular, 'dropoff')"
                          >
                            {{ popular.name }}
                            <span>{{ popular.address }}</span>
                          </li>
                        </ul>
                      </div> -->
                        <div class="list-autoComplete dropoff-autoComplete">
                          <ul
                            class="autoComplete-results"
                            id="dropoff-airportAutoCompleteResults"
                          ></ul>
                        </div>
                      </div>
                      <!-- End: Airport on Arrival -->
                    </div>
                    <!-- /.col-sm-6 -->
                  </div>
                </div>
                <div class="col-sm-4 search--boxPhase-2">
                  <div class="wrap__input-box">
                    <div class="col-sm-6">
                      <i class="ic-date-checkin pl-5"></i>
                      <VueCtkDateTimePicker
                        id="airportPickUpDate"
                        :min-date="minimumPickUpDate"
                        :max-date="maximumPickUpDate"
                        v-model="searchRequest.pickUpDate"
                        color="#025BC5"
                        format="YYYY-MM-DD"
                        formatted="MMM DD"
                        auto-close
                        only-date
                        no-label
                        no-header
                        no-button
                        no-button-now
                      />
                    </div>
                    <div class="col-sm-6">
                      <i class="ic-time"></i>
                      <VueCtkDateTimePicker
                        id="airportPickUpTime"
                        v-model="searchRequest.pickUpTime"
                        color="#025BC5"
                        format="HH:mm"
                        formatted="HH:mm"
                        minute-interval="5"
                        overlay
                        only-time
                        no-label
                        no-header
                        no-button
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <button
          type="submit"
          class="btn btn-primary"
          :disabled="!validateButton()"
        >
          Find Transportation
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import commonAirportService from "@/services/master/airportService.js";
import _ from "lodash";
import { companySelectorAirportTransfer } from "@/helpers/userHelper.js";

export default {
  props: {
    mode: { type: String, required: true },
    companies: { type: Array },
    services: { type: Object },
  },
  data() {
    return {
      isSubmitted: false,
      airports: [],
      popularDestinations: [],
      isModified: false,
      isDepartureFromAirport: false,
      isAvoidCrossCity: false,
      minimumPickUpDate: null,
      maximumPickUpDate: null,
      refreshSessionInterval: null,
      searchClone: {
        pickUpLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false,
        },
        dropOffLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false,
        },
      },
      searchRequest: {
        pickUpLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false,
        },
        dropOffLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false,
        },
        pickUpDate: null,
        pickUpTime: null,
        mode: "",
        company: null,
      },
      permissions: null,
      companyOption: [],
      modifySearch: false,
    };
  },
  validations() {
    return {
      searchRequest: {
        pickUpLocation: {
          name: { required },
        },
        dropOffLocation: {
          name: { required },
        },
        pickUpDate: { required },
        pickUpTime: { required },
      },
    };
  },
  computed: {
    hasCompanySelector() {
      if (this.permissions) {
        return companySelectorAirportTransfer(this.permissions);
      }
      return companySelectorAirportTransfer(this.services);
    },
    departureAirports() {
      if (
        this.searchRequest &&
        this.searchRequest.pickUpLocation &&
        this.searchRequest.pickUpLocation.name
      ) {
        const pattern = new RegExp(
          this.searchRequest.pickUpLocation.name.toLowerCase(),
          "i"
        );
        return this.airports.filter((airport) => {
          return (
            pattern.test(airport.air_code) ||
            pattern.test(airport.air_name) ||
            pattern.test(airport.ct_code) ||
            pattern.test(airport.ct_name) ||
            pattern.test(airport.cn_code) ||
            pattern.test(airport.cn_name)
          );
        });
      }
      return this.airports;
    },
    arrivalAirports() {
      if (
        this.searchRequest &&
        this.searchRequest.dropOffLocation &&
        this.searchRequest.dropOffLocation.name
      ) {
        const pattern = new RegExp(
          this.searchRequest.dropOffLocation.name.toLowerCase(),
          "i"
        );
        return this.airports.filter((airport) => {
          return (
            pattern.test(airport.air_code) ||
            pattern.test(airport.air_name) ||
            pattern.test(airport.ct_code) ||
            pattern.test(airport.ct_name) ||
            pattern.test(airport.cn_code) ||
            pattern.test(airport.cn_name)
          );
        });
      }
      return this.airports;
    },
  },
  mounted() {
    document.addEventListener("click", (event) => {
      const div = document.querySelector("#airportTransfer");
      if (div) {
        div
          .querySelectorAll(
            ".list-autoComplete, .popularCity, .geolocationAirport"
          )
          .forEach((element) => element.classList.remove("isOpen"));
      }
      if (
        $(
          "#airportTransfer .searchBox__input-from, #airportTransfer .searchBox__input-to"
        ).is(event.target)
      ) {
        const searchResult = $(event.target.parentElement).find(
          ".list-autoComplete"
        );
        const popularCity = $(event.target.parentElement).find(".popularCity");
        const geolocationAirport = $(event.target.parentElement).find(
          ".geolocationAirport"
        );

        if (
          searchResult.length > 0 &&
          searchResult[0].getElementsByTagName("li").length > 0
        ) {
          searchResult[0].classList.add("isOpen");
        } else if (
          popularCity.length > 0 &&
          popularCity[0].getElementsByTagName("li").length > 0
        ) {
          popularCity[0].classList.add("isOpen");
        } else if (
          geolocationAirport.length > 0 &&
          geolocationAirport[0].getElementsByTagName("li").length > 0
        ) {
          geolocationAirport[0].classList.add("isOpen");
        }
      }
    });

    document.addEventListener("keydown", this.handleEnter);
    $(".help-tip").popover({ trigger: "hover" });
  },
  async created() {
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    const profile = await this.$store.dispatch("user/getProfile");
    const userType = profile.userType;

    const minDays =
      userType === "TenantUser"
        ? 0
        : parseInt(
            this.$helper.extractSetting(publicSettings, "SearchMinDay", 0)
          );
    const maxMonths =
      userType === "TenantUser"
        ? 10000
        : parseInt(
            this.$helper.extractSetting(publicSettings, "BookingLimit", 0)
          );

    this.isAvoidCrossCity =
      this.$helper.extractSetting(publicSettings, "AvoidCrossCity", "false") ===
      "true";

    this.airports = await commonAirportService.getAll();

    const self = this;
    // subscribe messages
    this.$eventBus.$on("navigateToAirportTransfer", () =>
      self.$parent.autocomplete.refreshToken()
    );
    this.$eventBus.$on("bindAirportTransfer", this.bindModelFromModifySearch);

    this.refreshSessionInterval = setInterval(() => {
      self.$parent.autocomplete.refreshToken();
    }, 60000);

    const pickUpLocations = this.$helper
      .extractSetting(
        publicSettings,
        "AirportPickup",
        "-6.1275282|106.6537058|Soekarno-Hatta International Airport|Soekarno-Hatta International Airport, Tangerang City, Banten, Indonesia|ID|CGK"
      )
      .split("|");

    this.searchRequest.pickUpLocation = {
      latitude: parseFloat(pickUpLocations[0]),
      longitude: parseFloat(pickUpLocations[1]),
      name: pickUpLocations[2],
      address: pickUpLocations[3],
      country: pickUpLocations[4],
    };

    this.searchClone.pickUpLocation = {
      latitude: parseFloat(pickUpLocations[0]),
      longitude: parseFloat(pickUpLocations[1]),
      name: pickUpLocations[2],
      address: pickUpLocations[3],
      country: pickUpLocations[4],
    };

    if (pickUpLocations.length === 6) {
      this.isDepartureFromAirport = true;
      this.searchRequest.pickUpLocation.code = pickUpLocations[5];
      this.searchRequest.pickUpLocation.isAirportZone = true;

      this.searchClone.pickUpLocation.code = pickUpLocations[5];
      this.searchClone.pickUpLocation.isAirportZone = true;
    }

    const dropOffLocations = this.$helper
      .extractSetting(
        publicSettings,
        "AirportDropoff",
        "-6.1767112|106.8306527|Gambir Station|Gambir Station, Jalan Medan Merdeka Timur, Gambir, Central Jakarta City, Jakarta, Indonesia|ID"
      )
      .split("|");

    this.searchRequest.dropOffLocation = {
      latitude: parseFloat(dropOffLocations[0]),
      longitude: parseFloat(dropOffLocations[1]),
      name: dropOffLocations[2],
      address: dropOffLocations[3],
      country: dropOffLocations[4],
    };

    this.searchClone.dropOffLocation = {
      latitude: parseFloat(dropOffLocations[0]),
      longitude: parseFloat(dropOffLocations[1]),
      name: dropOffLocations[2],
      address: dropOffLocations[3],
      country: dropOffLocations[4],
    };

    if (dropOffLocations.length === 6) {
      this.isDepartureFromAirport = false;
      this.searchRequest.dropOffLocation.code = dropOffLocations[5];
      this.searchRequest.dropOffLocation.isAirportZone = true;

      this.searchClone.dropOffLocation.code = dropOffLocations[5];
      this.searchClone.dropOffLocation.isAirportZone = true;
    }

    this.searchRequest.pickUpDate = this.$helper.toStringDate(
      this.$helper.addDays(minDays)
    );

    this.searchRequest.pickUpTime = "10:00";

    this.minimumPickUpDate = this.$helper.toStringDate(
      this.$helper.addDays(minDays)
    );

    this.maximumPickUpDate = this.$helper.toStringDate(
      this.$helper.addMonths(maxMonths)
    );

    this.popularDestinations = [
      // {
      //   name: "Soekarno-Hatta International Airport",
      //   address: "Soekarno-Hatta International Airport, Tangerang City, Banten, Indonesia",
      //   country: "ID",
      //   isAirportZone: true,
      //   lat: -6.127119,
      //   lng: 106.6534595,
      // },
      // {
      //   name: "Gambir Station",
      //   address: "Gambir Station, Jalan Medan Merdeka Timur, Gambir, Central Jakarta City, Jakarta, Indonesia",
      //   country: "ID",
      //   isAirportZone: false,
      //   lat: -6.1767112,
      //   lng: 106.8306527,
      // },
      // {
      //   name: "Halim Perdana Kusuma",
      //   address: "Halim Perdana Kusuma, Jalan Medan Merdeka Timur, Gambir, Central Jakarta City, Jakarta, Indonesia",
      //   country: "ID",
      //   isAirportZone: true,
      //   lat: -6.265208800000002,
      //   lng: 106.8863459,
      // },
    ];
  },
  beforeDestroy() {
    // unsubscribe message
    this.$eventBus.$off("navigateToAirportTransfer");
    clearInterval(this.refreshSessionInterval);
    document.removeEventListener("keydown", this.handleEnter);
  },
  methods: {
    handleEnter(e) {
      if (this.mode !== "airport-transfer") return;
      if (e.key !== "Enter") return;

      if (e.target.classList.contains("vs__search")) {
        return;
      }

      e.preventDefault();
      this.search();
    },
    swapLocation() {
      const div = document.getElementById("airportTransfer");
      this.isDepartureFromAirport = !this.isDepartureFromAirport;

      // swap icon
      div.querySelector(".ic-switch").classList.toggle("onReverse");

      // swap location
      const tempLocation = this.searchRequest.pickUpLocation;
      this.searchRequest.pickUpLocation = this.searchRequest.dropOffLocation;
      this.searchRequest.dropOffLocation = tempLocation;

      // swap clone location
      const tempCloneLocation = this.searchClone.pickUpLocation;
      this.searchClone.pickUpLocation = this.searchClone.dropOffLocation;
      this.searchClone.dropOffLocation = tempCloneLocation;
    },
    bindModelFromModifySearch(
      searchParameter,
      services,
      companies,
      modifySearch
    ) {
      this.isModified = true;

      this.permissions = services;
      this.companyOption = companies;
      this.modifySearch = modifySearch;
      this.searchRequest = {
        pickUpLocation: {
          latitude: searchParameter.pickUpLocation.latitude,
          longitude: searchParameter.pickUpLocation.longitude,
          code: searchParameter.pickUpLocation.code,
          name: searchParameter.pickUpLocation.name,
          address: searchParameter.pickUpLocation.address,
          country: searchParameter.pickUpLocation.country,
          isAirportZone: searchParameter.pickUpLocation.isAirportZone,
        },
        dropOffLocation: {
          latitude: searchParameter.dropOffLocation.latitude,
          longitude: searchParameter.dropOffLocation.longitude,
          code: searchParameter.dropOffLocation.code,
          name: searchParameter.dropOffLocation.name,
          address: searchParameter.dropOffLocation.address,
          country: searchParameter.dropOffLocation.country,
          isAirportZone: searchParameter.dropOffLocation.isAirportZone,
        },
        pickUpDate: this.$helper.toDateString(
          searchParameter.pickUpDateTime,
          "YYYY-MM-DD"
        ),
        pickUpTime: this.$helper.toDateString(
          searchParameter.pickUpDateTime,
          "HH:mm"
        ),
        mode: searchParameter.mode,
        company: searchParameter.companyId,
      };

      this.searchClone = {
        pickUpLocation: {
          latitude: searchParameter.pickUpLocation.latitude,
          longitude: searchParameter.pickUpLocation.longitude,
          code: searchParameter.pickUpLocation.code,
          name: searchParameter.pickUpLocation.name,
          address: searchParameter.pickUpLocation.address,
          country: searchParameter.pickUpLocation.country,
          isAirportZone: searchParameter.pickUpLocation.isAirportZone,
        },
        dropOffLocation: {
          latitude: searchParameter.dropOffLocation.latitude,
          longitude: searchParameter.dropOffLocation.longitude,
          code: searchParameter.dropOffLocation.code,
          name: searchParameter.dropOffLocation.name,
          address: searchParameter.dropOffLocation.address,
          country: searchParameter.dropOffLocation.country,
          isAirportZone: searchParameter.dropOffLocation.isAirportZone,
        },
      };

      // indicates whether departure using geolocation or google maps autocomplete
      this.isDepartureFromAirport =
        this.searchRequest.pickUpLocation.code !== undefined;
    },
    onKeyupAirportGeolocation(target) {
      target.parentElement
        .querySelector(".geolocationAirport")
        .classList.add("isOpen");
    },
    onClickAirportGeolocation(airport, target) {
      switch (target) {
        case "pickup":
          this.searchRequest.pickUpLocation = {
            latitude: airport.lat,
            longitude: airport.long,
            code: airport.air_code,
            name: airport.air_name,
            address: airport.air_name,
            country: airport.cn_code,
          };
          break;
        case "dropoff":
          this.searchRequest.dropOffLocation = {
            latitude: airport.lat,
            longitude: airport.long,
            code: airport.air_code,
            name: airport.air_name,
            address: airport.air_name,
            country: airport.cn_code,
          };
          break;
      }
    },
    onClickPopularDestination(popular, target) {
      switch (target) {
        case "pickup":
          this.searchRequest.pickUpLocation = {
            latitude: popular.lat,
            longitude: popular.lng,
            name: popular.name,
            address: popular.address,
            country: popular.country,
            isAirportZone: popular.isAirportZone,
          };
          break;
        case "dropoff":
          this.searchRequest.dropOffLocation = {
            latitude: popular.lat,
            longitude: popular.lng,
            name: popular.name,
            address: popular.address,
            country: popular.country,
            isAirportZone: popular.isAirportZone,
          };
          break;
      }
    },
    onFocusAutoComplete(target) {
      target.value = "";
    },
    onBlurAutoComplete(target) {
      switch (target.name) {
        case "airportPickUpLocation":
          target.value = this.searchRequest.pickUpLocation.name;
          const isEqualPickUpLocation = _.isEqual(
            this.searchRequest.pickUpLocation,
            this.searchClone.pickUpLocation
          );
          if (!isEqualPickUpLocation) {
            this.searchRequest.pickUpLocation.name = "";
          }
          break;
        case "airportDropOffLocation":
          target.value = this.searchRequest.dropOffLocation.name;
          const isEqualDropOffLocation = _.isEqual(
            this.searchRequest.dropOffLocation,
            this.searchClone.dropOffLocation
          );
          if (!isEqualDropOffLocation) {
            this.searchRequest.dropOffLocation.name = "";
          }
          break;
      }
    },
    onKeyupAutoComplete(target) {
      document
        .querySelectorAll(".popularCity")
        .forEach((element) => element.classList.remove("isOpen"));

      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout((_) => {
        let autoCompleteResultElement = null;
        let options = {};
        let prefix = "";
        switch (target.name) {
          case "airportPickUpLocation":
            autoCompleteResultElement = document.getElementById(
              "pickup-airportAutoCompleteResults"
            );
            //options.country = self.searchRequest.dropOffLocation.country;
            if (self.isAvoidCrossCity) {
              const airport = this.airports.find(
                (x) => x.air_code === self.searchRequest.dropOffLocation.code
              );
              if (airport) {
                prefix = `${airport.ct_name}, `;
              }
            }
            break;
          case "airportDropOffLocation":
            autoCompleteResultElement = document.getElementById(
              "dropoff-airportAutoCompleteResults"
            );
            // options.country = self.searchRequest.pickUpLocation.country;
            if (self.isAvoidCrossCity) {
              const airport = this.airports.find(
                (x) => x.air_code === self.searchRequest.pickUpLocation.code
              );
              if (airport) {
                prefix = `${airport.ct_name}, `;
              }
            }
            break;
        }
        // reset suggestion result
        autoCompleteResultElement.innerHTML = "";

        // handle empty pick-up location keyword
        if (target.value === "") {
          autoCompleteResultElement.parentElement.classList.remove("isOpen");
          return;
        }

        self.$parent.autocomplete.getPredictions(
          `${prefix}${target.value}`,
          (predictions) => {
            // loop result
            predictions.forEach(function (prediction) {
              const item = document.createElement("li");
              item.innerHTML =
                self.$helper.getPlaceIcon(
                  prediction.types,
                  prediction.description
                ) +
                "<div class='point-of-view'>" +
                prediction.structured_formatting.main_text +
                "</div>" +
                "<span>" +
                prediction.structured_formatting.secondary_text +
                "</span>";
              item.addEventListener("click", (_) =>
                self.getPlace(target, prediction)
              );
              autoCompleteResultElement.appendChild(item);
            });
            // show the result
            autoCompleteResultElement.parentElement.classList.add("isOpen");
          },
          options
        );
      }, 200);
    },
    getPlace(target, prediction) {
      let self = this;
      let result = null;
      self.$parent.autocomplete.getPlace(prediction, (place) => {
        const isAirportZone =
          prediction.types.includes("airport") ||
          prediction.description.toLowerCase().includes("airport")
            ? true
            : false;

        switch (target.name) {
          case "airportPickUpLocation":
            result = document.getElementById(
              "pickup-airportAutoCompleteResults"
            );
            self.searchRequest.pickUpLocation = {
              latitude: place.latitude,
              longitude: place.longitude,
              name: place.name,
              address: place.address,
              country: place.country,
              isAirportZone: isAirportZone,
            };
            self.searchClone.pickUpLocation = {
              latitude: place.latitude,
              longitude: place.longitude,
              name: place.name,
              address: place.address,
              country: place.country,
              isAirportZone: isAirportZone,
            };
            self.handleDifferentCountry();
            break;
          case "airportDropOffLocation":
            result = document.getElementById(
              "dropoff-airportAutoCompleteResults"
            );
            self.searchRequest.dropOffLocation = {
              latitude: place.latitude,
              longitude: place.longitude,
              name: place.name,
              address: place.address,
              country: place.country,
              isAirportZone: isAirportZone,
            };
            self.searchClone.dropOffLocation = {
              latitude: place.latitude,
              longitude: place.longitude,
              name: place.name,
              address: place.address,
              country: place.country,
              isAirportZone: isAirportZone,
            };
            break;
        }
        // everytime user select the prediction, result list should be reset
        result.innerHTML = "";
      });
    },
    buildQueryParam(request) {
      const queryParam = {};

      // pick-up
      queryParam.plt = request.pickUpLocation.latitude;
      queryParam.plg = request.pickUpLocation.longitude;
      queryParam.pcd = request.pickUpLocation.code;
      queryParam.pad = request.pickUpLocation.address;
      queryParam.pnm = request.pickUpLocation.name;
      queryParam.pcn = request.pickUpLocation.country
        ? request.pickUpLocation.country
        : request.dropOffLocation.country;
      queryParam.pia = request.pickUpLocation.isAirportZone;

      // drop-off
      queryParam.dlt = request.dropOffLocation.latitude;
      queryParam.dlg = request.dropOffLocation.longitude;
      queryParam.dcd = request.dropOffLocation.code;
      queryParam.dad = request.dropOffLocation.address;
      queryParam.dnm = request.dropOffLocation.name;
      queryParam.dcn = request.dropOffLocation.country
        ? request.dropOffLocation.country
        : request.pickUpLocation.country;
      queryParam.dia = request.dropOffLocation.isAirportZone;

      // start rent
      queryParam.ptm = `${request.pickUpDateTime.year}.${request.pickUpDateTime.month}.${request.pickUpDateTime.day}-${request.pickUpDateTime.hour}.${request.pickUpDateTime.minute}`;

      // service type
      queryParam.svc = "airporttransfer";

      // HACK: handle duplication routing
      queryParam.ver = Math.random().toString(36).substr(2, 9);

      // search mode
      queryParam.mode = request.mode;

      // companyId
      queryParam.company = request.company;

      return queryParam;
    },
    search() {
      this.isSubmitted = true;
      this.$v.searchRequest.$touch();
      if (this.$v.searchRequest.$error) {
        return;
      }
      // parse datetime
      if (this.searchRequest.pickUpDate && this.searchRequest.pickUpTime) {
        const pickUpDates = this.searchRequest.pickUpDate.split("-");
        const pickUpTimes = this.searchRequest.pickUpTime.split(":");
        this.searchRequest.pickUpDateTime = {
          year: parseInt(pickUpDates[0]),
          month: parseInt(pickUpDates[1]),
          day: parseInt(pickUpDates[2]),
          hour: parseInt(pickUpTimes[0]),
          minute: parseInt(pickUpTimes[1]),
        };

        // this.searchRequest.mode = this.mode;
        this.searchRequest.mode = "Inquiry";

        if (this.searchRequest.mode === "Inquiry") {
          if (this.isModified) {
            this.$eventBus.$emit(
              "executeModifySearch",
              this.buildQueryParam(this.searchRequest)
            );
          } else {
            this.$router.push({
              path: "/availability/inquiry",
              query: this.buildQueryParam(this.searchRequest),
            });
          }
        } else {
          if (this.isModified) {
            this.$eventBus.$emit(
              "executeModifySearch",
              this.buildQueryParam(this.searchRequest)
            );
          } else {
            this.$router.push({
              path: "/availability/instant",
              query: this.buildQueryParam(this.searchRequest),
            });
          }
        }
      }
    },
    handleDifferentCountry() {
      if (
        this.searchRequest.pickUpLocation.country !=
        this.searchRequest.dropOffLocation.country
      ) {
        this.searchRequest.dropOffLocation = {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
        };

        const dropOffTextbox = document.getElementsByName(
          "airportDropOffLocation"
        )[0];

        if (dropOffTextbox) {
          dropOffTextbox.click();
          dropOffTextbox.focus();
        }
      }
    },
    validateButton() {
      return (
        this.searchRequest.pickUpLocation.name &&
        this.searchRequest.dropOffLocation.name
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/availability/form/Transfer.vue